export const ADD_PAYMENT_METHOD_ERROR_TITLE =
  "We are unable to add your payment method";
export const TRY_AGAIN_CTA = "Try Again";
export const CAP_ONE_INVALID_CREDIT_CARD_SUBTITLE =
  "Ensure you are using an eligible Capital One credit card.";
export const EDIT_PAYMENT_METHOD = "Edit Payment Method";
export const CARD_VERIFY_TEXT = "Adding your card";

export const REVIEW_TRIP_CTA_TEXT = "Review my trip";
export const MOBILE_HEADING_TITLE_TEXT = "Rewards and payment";
export const MOBILE_HEADING_SUBTITLE_TEXT =
  "Combine travel offers, travel credits, rewards, and your Capital One credit card to book this trip.";

export const NO_SELECTED_REWARDS_TEXT =
  "Apply your rewards or select pay with your Capital One credit card to continue.";
export const NO_SELECTED_CARD_TEXT =
  "Select a payment method to complete your booking.";

export const PAYMENT_EARN_INFO_TOOLTIP_TEXT =
  "You will only earn rewards on the amount paid with your Capital One credit card, not including credits and/or rewards redeemed for your booking.";
